<template>
  <div class="app-ecommerce">
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3"
      >
        <div class="d-flex flex-column justify-content-center">
          <h4 class="mb-1 mt-3">Modification Etiquette</h4>
        </div>
        <div class="d-flex align-content-center flex-wrap gap-3">
          <div class="d-flex gap-3">
            <button
              type="submit"
              class="btn btn-primary"
              @click="showMsgBoxEdit()"
            >
              Enregistrer
            </button>
          </div>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header">
          <h5 class="card-tile mb-0">Information étiquette</h5>
        </div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col">
              <div class="card-header" style="padding: 0.5rem">
                <H5 class="form-label">Nom </H5>
              </div>

              <input
                class="form-control"
                placeholder="Nom étiquette"
                v-model="etiquetteInformation.name"
              />

              <label
                >Le nom est la façon dont il apparaît sur votre site.</label
              >
            </div>
            <div class="col">
              <div class="card-header" style="padding: 0.5rem">
                <h5 class="form-label">Slug</h5>
              </div>
              <input
                class="form-control"
                placeholder="SLUG"
                v-model="etiquetteInformation.slug"
              />

              <label
                >Le « slug » est la version du nom normalisée pour les
                URL.</label
              >
            </div>
          </div>
          <div>
            <H5 class="form-label">Description </H5>
            <quill-editor v-model="etiquetteInformation.description" />
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { BOverlay } from "bootstrap-vue";
import websiteURL from "@/websiteURL";
import axios from "axios";
export default {
  components: {
    quillEditor,
    BOverlay,
  },
  data() {
    return {
      loading: false,
      etiquetteInformation: [],
    };
  },
  async beforeRouteEnter(to, from, next) {
    const apiUrl =
      websiteURL.WEBSITE + `wp-json/wc/v3/products/tags/${to.params.id}`;
    const consumerKey = websiteURL.CONSUMERKEY;
    const consumerSecret = websiteURL.CONSUMERSECRET;
    try {
      const response = await axios.get(apiUrl, {
        auth: {
          username: consumerKey,
          password: consumerSecret,
        },
      });
      next((vm) => {
        vm.etiquetteInformation = response.data;
      });
    } catch (error) {
      alert("Une erreur s'est produite, veuillez réessayer plus tard", error);
      next(null);
    }
  },

  methods: {
    //Permet la modification des informations de l'etiquette
    async editEtiquette() {
      const apiUrl =
        websiteURL.WEBSITE +
        `wp-json/wc/v3/products/tags/${this.etiquetteInformation.id}`;
      const consumerKey = websiteURL.CONSUMERKEY;
      const consumerSecret = websiteURL.CONSUMERSECRET;
      try {
        const data = {
          name: this.etiquetteInformation.name,
          description: this.etiquetteInformation.description,
          slug: this.etiquetteInformation.slug,
        };

        const response = await axios.put(apiUrl, data, {
          auth: {
            username: consumerKey,
            password: consumerSecret,
          },
        });
        this.editConfirmeToastMsg("info");
      } catch (error) {
        alert(
          "Une erreur s'est produite lors de la modification de l'étiquette",
          error
        );
      }
    },
    //Message de confirmation de modification
    showMsgBoxEdit() {
      this.boxMsgEdit = "";
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr de vouloir mettre à jour l'étiquette?", {
          title: "Confirmation",
          size: "sm",
          okVariant: "primary",
          okTitle: this.loading ? "Loading..." : "Confirmer",
          cancelTitle: "Annuler",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxMsgEdit = value;
          if (value) {
            if (value) {
              this.loading = true;
              this.editEtiquette().then(() => {
                this.loading = false;
              });
            }
          }
        });
    },
    editConfirmeToastMsg(variant = null) {
      this.$bvToast.toast("L'étiquette a bien été mise à jour", {
        title: `Etiquette ${variant || "default"}`,
        variant,
        solid: true,
        href: this.permalink,
      });
    },
  },
};
</script>
<style lang="scss">
// Style
.ql-snow {
  &.ql-container {
    .ql-editor {
      min-height: 150px;
    }
  }
}
</style>
